import { Typography } from "@mui/material";
import { ModalWrapper } from "components/modalWrapper";

interface RebateModalProps {
  open: boolean;
  onClose: () => void;
}

export const RebateModal = (props: RebateModalProps) => {
  return (
    <ModalWrapper
      title="Benefícios + Wellhub"
      subtitle=""
      open={props.open}
      handleClose={props.onClose}
    >
      <Typography variant="body2">
        Rebate agora é ilegal! Continue oferecendo benefícios incríveis por um
        preço acessível! Com Caju você tem respaldo jurídico e mantem sua
        conformidade com PAT.
      </Typography>
    </ModalWrapper>
  );
};
